import React, { useContext } from "react";
import "./Footer.css";
import corner from "../../assets/corner.png";
import cornerTR from "../../assets/cornerTR.png";
import cornerBR from "../../assets/cornerBR.png";
import cornerBL from "../../assets/cornerBL.png";
import ig from "../../assets/footer-social/ig.png";
import linkedin from "../../assets/footer-social/linkedin.png";
import twitter from "../../assets/footer-social/twitter.png";
import seperator from "../../assets/seperator.png";
import locationMarker from "../../assets/footer-social/location.png";
import AppContext from "../../util/AppContext"
import { Link } from "react-router-dom";

const Footer = ({ page }) => {
  const myCtx = useContext(AppContext);

  return (
    <div className={`section ${page}footerOuterContainerRestPages`}>
      <div className={`container-fluid footer-fullcontainer ${page}footer-fullcontainer`}>
        <div className="container footer-inside-container">
          <div className="row justify-content-center footer-inside-row">
            <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 footerTryRevirtForFreeCol">
              <div>
                <img src={corner} alt="" id="topleft" />
                <img src={cornerTR} alt="" id="topright" />
                <img src={cornerBR} alt="" id="bottomright" />
                <img src={cornerBL} alt="" id="bottomleft" />
                <p>try revirt for free</p>
                <button>get started</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid social-footer">
        <div className="container">
          <div className="row justify-content-center gy-3" style={{
            margin: 0
          }}>
            <div
              className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 footer-pp-col"
              style={{
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center',
                margin: 0,
                padding: 0
              }}
              >
              <div className="footer-policy-links">
                <Link to='/privacypolicy' className="pp-link-footer">
                  <p className="pp-footer-name">privacy policy</p>
                </Link>
                <p className="pp-footer-name">terms of use</p>
              </div>
              {window.innerWidth > 767 ? (
                <div>
                  <img src={seperator} alt="" className="seperator" />
                </div>
              ) : (
                <></>
              )}
            </div>
            <div
              className="social-footer-icons-container col-xl-1 col-lg-2 col-md-3 col-sm-3 col-5"
            >
              <img src={ig} alt="" />
              <div className="icons-container-1">
                <img src={twitter} alt="" />
              </div>
              <div className="icons-container-2">
                <img src={linkedin} alt="" />
              </div>
            </div>
            <div
              className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12 contact-footer-col"
            >
              {window.innerWidth > 767 ? (
                <div>
                  <img src={seperator} alt="" className="seperator" />
                </div>
              ) : (
                <></>
              )}
              <div>
                <p className="contact-footer">contact</p>
                <p className="email-footer">office@revirt.space</p>
              </div>
            </div>
            <div
              className="col-xl-6 col-lg-6 col-md-3 col-sm-12 col-12 locationcol col-12">
              <img src={locationMarker} alt="" className="locationIcon" />
              &nbsp;&nbsp;
              <p>from our offices in the revirt metaverse</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
